var _defs, _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCartAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 6.375,
    cy: 20.968,
    r: 1.875
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 13.875,
    cy: 20.968,
    r: 1.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m.75 7.093 2.329 7.887a1.5 1.5 0 0 0 1.45 1.113h10.818A1.5 1.5 0 0 0 16.8 14.98l3.238-12.154a2.249 2.249 0 0 1 2.174-1.67h1.038M9.75 6.343v6M6.75 9.343h6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartAdd);
export default __webpack_public_path__ + "static/media/shopping-cart-add.e3a9594c3ff753c7e14a751bb74d35e1.svg";
export { ForwardRef as ReactComponent };